export const regex = "^[\\w\\.\\!@#$%&*+\\-=\\?\\^'\\{\\|\\}]{4,40}$";
export default regex;
